import React, { useContext, useState } from 'react';
import InputRegister from '../../blocks/ui/InputDesign';
import { organisationValidate } from '../../../utils/validator';

import { DContext } from '../../../context/Datacontext';
import { createClient } from '../../services/managerApi/clientsApi';
import { compressImage } from '../../../utils/compressImages';

export default function ClientRegisterForm() {
    const { BeURL, showAlert, currentUser } = useContext(DContext)

    const [client, setClient] = useState({
        companyName: "",
        companyWebsite: '',
        industry: '',
        active: true
    })

    const [errors, setErrors] = useState({ client: {} })

    const [logoPreview, setLogoPreview] = useState("")
    const [clientLogo, setClientLogo] = useState("")

    const fileToBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });

    const handleLogoChange = async (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        if (!file.type || !file.type.startsWith("image/")) {
            setErrors((prev) => ({
                ...prev,
                client: { ...prev.client, clientLogo: "Only image files are allowed" }
            }));
            setClientLogo("");
            setLogoPreview("");
            return;
        }

        setErrors((prev) => ({
            ...prev,
            client: { ...prev.client, clientLogo: "" }
        }));

        const compressedFile = await compressImage(file, { maxSizeMB: 0.7 });
        const base64 = await fileToBase64(compressedFile);
        setClientLogo(base64);
        setLogoPreview(base64);
    };

    const handleClient = (name, value, checked) => {

        const finalValue = name === "active" ? checked : value;

        setClient(prev => ({
            ...prev,
            [name]: finalValue,
        }));

        let errmsg;

        if (name !== 'companyWebsite')
            errmsg = organisationValidate(name, finalValue);

        if (value && name === 'companyWebsite') {
            errmsg = organisationValidate('companyWebsite', finalValue);
        }

        // errmsg = organisationValidate(, finalValue);

        setErrors((prev) => ({
            ...prev,
            client: {
                ...prev.client,
                [name]: errmsg,
            },
        }));
    };

    const isFormValid = (errors) => {
        // Check if all error objects are empty
        return (
            Object.values(errors.client || {}).every((err) => !err)
        )
    }

    const handleCreate = async () => {


        const payload = {
            'clientName': client.companyName,
            'clientWeblink': client.companyWebsite,
            'industry': client.industry,
            'isActive': client.active,
            'userId': currentUser.id,
            'companyId': currentUser.company.companyId
        }

        if (clientLogo) {
            payload.clientLogo = clientLogo;
        }

        await createClient(BeURL, showAlert, payload, setClient)
    }

    return (
        <div className=" min-h-[85vh] flex items-center justify-center p-4">
            <div className="bg-white border shadow-xl rounded-2xl w-full max-w-5xl p-8">
                <h2 className="text-3xl font-bold mb-8 text-primary-600 text-center">
                    Register New Client
                </h2>

                <div className="grid grid-cols-2 gap-4">

                    {[{
                        label: "Company Name", name: "companyName", value: client.companyName, error: errors.client?.companyName, mandatory: true, placeholder: "Company Name",
                        required: true
                    },
                    {
                        label: " Company Website", name: "companyWebsite", value: client.companyWebsite, error: errors.client?.companyWebsite, placeholder: "Ex: https://www.example.com/",
                        required: true
                    },
                    { label: " Industry", name: "industry", value: client.industry, error: errors.client?.industry, placeholder: "Company Industry Type", mandatory: true },].map((field, idx) => (
                        <div key={idx} className="bg-gray-50 p-4 rounded-xl shadow-inner">
                            <InputRegister
                                label={field.label}
                                value={field.value}
                                name={field.name}
                                mandatory={field.mandatory}
                                required
                                placeholder={field.placeholder}
                                type="text"
                                className="w-full"
                                error={field.error}
                                onChange={(e) => handleClient(e.target.name, e.target.value)}
                            />
                        </div>


                    ))}
                    <div className="bg-gray-50 p-4 rounded-xl shadow-inner">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Client Logo (optional)</label>
                        {logoPreview ? (
                            <img src={logoPreview} alt="Client Logo" className="h-20 w-20 object-contain rounded border mb-2" />
                        ) : null}
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleLogoChange}
                            className="w-full"
                        />
                        {errors.client?.clientLogo ? (
                            <p className="text-xs text-red-500 mt-1">{errors.client.clientLogo}</p>
                        ) : null}
                    </div>
                    <div className='flex items-center px-7'>
                        <input type="checkbox" className="w-5 px-10"
                            name="active" checked={client.active || false}
                            onChange={(e) => handleClient(e.target.name, e.target.value, e.target.checked)}
                        />Active
                    </div>


                    <div className="md:col-span-2 flex justify-center mt-4">
                        <button
                            type="submit"
                            disabled={!isFormValid(errors)}
                            className={`px-4 py-2 rounded ${isFormValid(errors)
                                ? "bg-secondary-200 text-white hover:bg-secondary-500"
                                : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                            onClick={handleCreate}
                        >
                            Create Client
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
